import gsap from "gsap";
import BodyScroll from "../helpers/BodyScroll";

const bodyScroll = new BodyScroll();

const throttle = (func, ms) => {
  let isThrottled = false,
    savedArgs,
    savedThis;

  function wrapper() {
    if (isThrottled) {
      // (2)
      savedArgs = arguments;
      savedThis = this;
      return;
    }

    func.apply(this, arguments); // (1)

    isThrottled = true;

    setTimeout(function () {
      isThrottled = false; // (3)
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }

  return wrapper;
};

window.scrollWidth = 0;
const getScrollWidth = throttle(() => {
  let div = document.createElement("div");
  div.style.overflowY = "scroll";
  div.style.width = "50px";
  div.style.height = "50px";
  document.documentElement.append(div);
  let width = div.offsetWidth - div.clientWidth;
  div.remove();
  window.scrollWidth = width;
}, 1000);

getScrollWidth();

document.addEventListener("DOMContentLoaded", () => {
  const appleExpression = /Apple/i;
  const safariExpression = /Safari/i;
  const isAppleSafari = () => {
    return appleExpression.test(navigator.vendor) && safariExpression.test(navigator.userAgent);
  };

  let safari = isAppleSafari();

  // Usage example:

  const header = document.querySelector(".header");
  const openMenuButton = document.querySelector(".header__open-menu");
  const navStatic = document.querySelector(".nav-static");
  const navMobile = document.querySelector(".nav-mobile");
  const navMobileList = navMobile.querySelector(".nav__list");
  const backButtons = navMobile.querySelectorAll(".sub-nav__back");

  const duration = 0.3;
  const delay = 0;
  let openNav = null;

  let animate = false;

  const navs = document.querySelectorAll(".nav");
  let navItems = [];

  navs.forEach((nav) => {
    navItems = [...navItems, ...nav.querySelectorAll(".nav__item")];
  });

  navs.forEach((nav) => {
    if (nav.classList.contains("nav-mobile")) return;
    const subNavs = nav.querySelectorAll(":scope .sub-nav > .sub-nav__list > .sub-nav__item > .sub-nav > .sub-nav__list > .sub-nav__item ");

    const top = nav.classList.contains("nav-static") ? 107 : 27;

    subNavs.forEach((subNav) => {
      const subItem = subNav.querySelector(":scope > .sub-nav");
      const subList = subNav.parentElement.closest(".sub-nav__list");
      if (subItem && subList) {
        const item = subItem.querySelector(".sub-nav__item");
        let throttle;
        const scroll = () => {
          item.style.marginTop = subNav.offsetTop - top - subList.scrollTop < 0 ? 0 : subNav.offsetTop - subList.scrollTop - top + "px";
          item.closest(".sub-nav__list").style.overflow = "hidden";
          clearTimeout(throttle);
          throttle = setTimeout(() => {
            item.closest(".sub-nav__list").style.overflow = "hidden auto";
          }, 300);
        };

        scroll();
        window.addEventListener("resize", scroll);
        subList.addEventListener("scroll", scroll);
      }
    });
  });

  let openItems = [];

  navItems = navItems.filter((item) => item.querySelector(".sub-nav"));

  let timeLine = gsap.timeline();

  const timelineAddClose = (subNav) => {
    timeLine.to(subNav, { overflow: "hidden", delay, duration: 0 });
    timeLine.to(subNav, { width: 0, minWidth: 0, duration, delay });
    if (safari) timeLine.to(subNav, { backdropFilter: "unset" });
  };

  let closes = false;

  const closeAllItems = () => {
    openItems.forEach((item) => {
      item.querySelector(".sub-nav__link--active")?.classList.remove("sub-nav__link--active");
      let subNav = item.querySelector(".sub-nav");
      if (subNav) timelineAddClose(subNav);
    });

    if (openNav.classList.contains("nav-static")) {
      timeLine.to(openNav, { x: "-100%", duration, delay });
      timeLine.to(openNav, { x: "-100%", duration, delay });
    }
    setTimeout(() => {
      openNav.classList.remove("nav--open");
      openNav.querySelector(".nav__link--active")?.classList.remove("nav__link--active");
      document.documentElement.style.overflow = "hidden auto";
      openItems = [];
      openNav = null;
      animate = false;
      if (!header.classList.contains("header-main")) gsap.to(header, { y: 0, duration, delay });
      closes = false;
    }, openItems.length * 0.3 * 1000);
  };

  document.addEventListener("click", (e) => {
    if (openItems.length || (openNav && !e.target.classList.contains("nav__list"))) closeAllItems();
  });
  window.addEventListener("keyup", (e) => {
    if (e.key === "Escape" && openNav) {
      closeAllItems();
    }
  });

  const closeItem = (item) => {
    const indexItem = openItems.findIndex((child) => child.closest(".sub-nav") === item.closest(".sub-nav"));
    if (indexItem) {
      for (let i = 0; i < indexItem; i++) {
        openItems[i].querySelector(".sub-nav__link--active")?.classList.remove("sub-nav__link--active");
        let subNav = openItems[i].querySelector(".sub-nav");
        if (subNav) timelineAddClose(subNav);
      }
    }
    let subNav = item.querySelector(".sub-nav");
    if (subNav) timelineAddClose(subNav);
    item.querySelector(".sub-nav__link--active")?.classList.remove("sub-nav__link--active");
    openItems = openItems
      .map((child, index) => {
        if (index > indexItem) return child;
      })
      .filter((child) => child);
  };

  let openItemsMobile = [];

  const backMobile = (item) => {
    const indexItem = openItemsMobile.findIndex((child) => child === item);
    const subNav = item.querySelector(":scope > .sub-nav__list > .sub-nav__item > .sub-nav");

    timeLine.to(openItemsMobile[indexItem + 1], { x: "0", duration, delay });
    timeLine.to(item, { opacity: 0, delay, duration: 0, pointerEvents: "none" });
    if (subNav) timeLine.to(subNav, { opacity: 0, delay, duration: 0, pointerEvents: "none" });

    openItemsMobile = openItemsMobile.filter((child) => child !== item);
  };

  const openItemsFuncMobile = (item) => {
    navMobile.scrollTop = 0;
    const subNav = item.querySelector(":scope .sub-nav");

    if (openItemsMobile.find((child) => child === subNav)) return;
    const backButton = subNav.querySelector(".sub-nav__back span");
    backButton.innerHTML = item.querySelector("a").innerText;

    timeLine.to(subNav, { opacity: 1, delay, duration: 0, pointerEvents: "auto" });
    if (openItemsMobile.length === 1) {
      timeLine.to(navMobileList, { x: "-100vw", duration, delay });
    } else {
      const subNav = item.closest(".sub-nav");
      if (subNav) timeLine.to(subNav, { x: "-100vw", duration, delay });
    }
    openItemsMobile.unshift(subNav);
    if (subNav) {
      subNav.querySelectorAll(":scope > .sub-nav__list > .sub-nav__item").forEach((child) => {
        if (!child.querySelector(".sub-nav")) {
          child.addEventListener("click", (e) => {
            e.stopPropagation();
          });
          return;
        }

        child.addEventListener("click", (e) => {
          e.stopPropagation();
          e.preventDefault();
          openItemsFuncMobile(child);
        });
      });
    }
  };

  navItems.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.stopPropagation();
      if (!openNav) {
        // bodyScroll.disable()
        document.documentElement.style.overflow = "hidden";
        item.closest(".nav")?.classList.add("nav--open");
        openNav = item.closest(".nav");
      }
      if (window.innerWidth <= 1024) {
        e.preventDefault();
        openItemsFuncMobile(item);
      }
    });
    item.addEventListener("touchEvent", (e) => {
      e.stopPropagation();
      if (!openNav) {
        // bodyScroll.disable()
        document.documentElement.style.overflow = "hidden";
        item.closest(".nav")?.classList.add("nav--open");
        openNav = item.closest(".nav");
      }
    });
  });

  document.addEventListener("mousemove", (e) => {
    if (e.target.closest(".nav__list") || !openItems.length || closes) return;
    closes = true;
    bodyScroll.enable();
    closeAllItems();
  });

  const closeMenuMobile = () => {
    openMenuButton.classList.remove("header__open-menu--animate");
    openMenuButton.classList.add("header__open-menu--close");
    timeLine.to(navMobile, { x: "-100%", delay, duration });
    openNav = null;
    bodyScroll.enable();
  };

  const toggleMenu = () => {
    if (openMenuButton.classList.contains("header__open-menu--animate")) {
      closeMenuMobile();
    } else {
      bodyScroll.disable();
      openNav = navMobile;
      openMenuButton.classList.remove("header__open-menu--close");
      openMenuButton.classList.add("header__open-menu--animate");
      timeLine.to(navMobile, { x: 0, delay, duration });
    }
  };

  const clickOutSideMenuHandler = (e) => {
    if (!e.target.classList.contains("nav__list")) {
      navStatic.classList.remove("nav--open");
      bodyScroll.enable();
      document.removeEventListener("click", clickOutSideMenuHandler);
    }
  };

  openMenuButton.addEventListener("click", (e) => {
    e.stopPropagation();
    if (window.innerWidth > 1024) {
      navStatic.classList.toggle("nav--open");

      bodyScroll.disable();
      navStatic.classList.add("nav--open");
      timeLine.to(navStatic, { x: 0, delay, duration });
      openNav = navStatic;
      if (!header.classList.contains("header-main")) gsap.to(header, { y: "-100%", duration, delay });
    } else {
      toggleMenu();
      navMobile.classList.add("nav--open");
      if (!openItemsMobile.find((item) => item === navMobileList)) openItemsMobile.unshift(navMobileList);
      openNav = navMobile;
    }

    document.addEventListener("click", clickOutSideMenuHandler);
  });

  backButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.stopPropagation();
      const subNav = button.closest(".sub-nav");
      backMobile(subNav);
    });
  });

  let size = window.innerWidth;

  window.addEventListener("resize", () => {
    if (!openNav) return;
    if (window.innerWidth > 1024 && size <= 1024) {
      bodyScroll.enable();
      closeMenuMobile();
      size = window.innerWidth;
    }
    if (window.innerWidth <= 1024 && size > 1024) {
      bodyScroll.enable();
      if (openItems.length) closeAllItems();
      size = window.innerWidth;
    }
  });
});
